const perfisBA = {

  COORDENADOR_NDI: 'COORDENADOR_NDI',
  ANALISTA_NDI: 'ANALISTA_NDI',
  COORDENADOR_NOT: 'COORDENADOR_NOT',
  ANALISTA_NOT: 'ANALISTA_NOT',
  COORDENADOR_NAJ: 'COORDENADOR_NAJ',
  ANALISTA_NAJ: 'ANALISTA_NAJ',
  COORDENADOR_CAF: 'COORDENADOR_CAF',
  SUPERINTENDENTE_GAB: 'SUPERINTENDENTE_GAB',
  COORDENADOR_NUTIT: 'COORDENADOR_NUTIT',
  ANALISTA_NUTIT: 'ANALISTA_NUTIT',
  ARQUIVO: 'ARQUIVO',
  EXTERNO: 'EXTERNO',
  RELATORIOS: 'RELATORIOS',
  PREFEITURA: 'PREFEITURA',
  PRODUTIVIDADE: 'PRODUTIVIDADE',
  FINANCEIRO: 'FINANCEIRO',
  TECNICO_DE_CAMPO: 'TECNICO_DE_CAMPO',
  ADMINISTRADOR_DE_ACESSO: 'ADMINISTRADOR_DE_ACESSO',
  GOVERNADOR: 'GOVERNADOR',
  ASSESSOR_JURIDICO: 'ASSESSOR_JURIDICO',
  SISTEMA: 'SISTEMA'
}

export default perfisBA



// WEBPACK FOOTER //
// ./src/utils/ba/perfis.js